module.exports = __webpack_public_path__ + "static/media/strips.db59377e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/strips.svg
// module id = 636
// module chunks = 0